import { ChangeDetectorRef, Component, QueryList, ViewChildren } from '@angular/core';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';
import { CustomComponentComponent, DialogPosition } from '../custom-component/custom-component.component';
import { Client } from 'src/app/models/client.model';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { CustomerFormService } from 'src/app/services/customer-form.service';
import { MessageService } from 'primeng/api';
import { UserService } from 'src/app/services/user.service';
import { ClientsService } from 'src/app/services/clients.service';
import { ServicesService } from 'src/app/services/services.service';
import { ProductsService } from 'src/app/services/products.service';
import { Router } from '@angular/router';
import { Service } from 'src/app/models/service.model';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { ModalProFeaturesComponent } from '../modal-pro-features/modal-pro-features.component';
import { ProFeaturesSwiperComponent } from '../pro-features-swiper/pro-features-swiper.component';
import { PrescriptionTemplate, PrescriptionTemplatesService } from 'src/app/services/prescription-templates.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-create-custom-form',
  standalone: true,
  imports: [SharedModule, CustomComponentComponent, ProFeaturesSwiperComponent],
  templateUrl: './create-custom-form.component.html',
  styleUrl: './create-custom-form.component.scss',
  providers: [MessageService]
})
export class CreateCustomFormComponent {
  selectedImage;
  galleryImages;
  selectedQueType;
  selectedQueIndex = 0;
  @ViewChildren(CustomComponentComponent) customComponent: QueryList<CustomComponentComponent>;
  ColumnMode: string
  search = '';
  isSubmitting: boolean = false;
  isFormSubmitting: boolean = false;
  isFormNameSubmitting: boolean = false;
  isDeleting: boolean = false;
  clientList: Client[] = [];
  selectedClient: Client[] = [];
  isInputChanged = false;
  displayedColumns: string[] = ['typeform', 'questions', 'updated', 'actions'];
  prescriptionTemplates: PrescriptionTemplate[] = [];

  constructor(private fb: FormBuilder,
    private customerFormService: CustomerFormService,
    private messageService: MessageService,
    private cd: ChangeDetectorRef,
    public userService: UserService,
    private clientsService: ClientsService,
    private servicesService: ServicesService,
    private productService: ProductsService,
    private router: Router,
    private prescriptionTemplatesService: PrescriptionTemplatesService
  ) {
    this.galleryImages = this.customerFormService.galleryImages;
    // Create Custom form
    this._initCreateCustomForm();
    this._initUpdateForm();
  }

  imageList = [
    {
      id: 0,
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRTDZX8bPP_MfyRACtlXyu4P2_e-YzZLop5PV7aT0bLF_LZ-nQlwWwxox-UqPMg6iLTTc8&usqp=CAU'
    },
    {
      id: 1,
      image: 'https://images.squarespace-cdn.com/content/v1/58d1fe00cd0f6829bded7f92/1494562127164-IBDQ97GUJ2JDV49780LB/heel+pain'
    },
    {
      id: 2,
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTpLRONRNuYCJhBuE5RKug8R5g9MWt71eabQFaMqvBzahlCejbczyKcYnQ4ro29L1rJxzo&usqp=CAU'
    },
    {
      id: 3,
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRTDZX8bPP_MfyRACtlXyu4P2_e-YzZLop5PV7aT0bLF_LZ-nQlwWwxox-UqPMg6iLTTc8&usqp=CAU'
    },
    {
      id: 4,
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRTDZX8bPP_MfyRACtlXyu4P2_e-YzZLop5PV7aT0bLF_LZ-nQlwWwxox-UqPMg6iLTTc8&usqp=CAU'
    },
    {
      id: 5,
      image: 'https://images.squarespace-cdn.com/content/v1/58d1fe00cd0f6829bded7f92/1494562127164-IBDQ97GUJ2JDV49780LB/heel+pain'
    },
    {
      id: 6,
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTpLRONRNuYCJhBuE5RKug8R5g9MWt71eabQFaMqvBzahlCejbczyKcYnQ4ro29L1rJxzo&usqp=CAU'
    },
    {
      id: 7,
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRTDZX8bPP_MfyRACtlXyu4P2_e-YzZLop5PV7aT0bLF_LZ-nQlwWwxox-UqPMg6iLTTc8&usqp=CAU'
    },
  ]

  private readonly baseQuestionTypes = ['inputText', 'longText', 'email', 'dropdown', 'uniqueChoice', 'multipleChoice', 'customComponents', 'productsList', 'insolesPrescription'];

  private readonly baseQuestionTypeArr = [
    {
      type: 'Text', questionTypes: [
        { name: 'Input Text', value: 'inputText' },
        { name: 'Long Text', value: 'longText' },
      ]
    },
    {
      type: 'Contact Info', questionTypes: [
        { name: 'Email', value: 'email' },
      ]
    },
    {
      type: 'Choices', questionTypes: [
        { name: 'Unique Choice', value: 'uniqueChoice' },
        { name: 'Multiple Choice', value: 'multipleChoice' },
        { name: 'Dropdown', value: 'dropdown' },
      ]
    },
    {
      type: 'Others', questionTypes: [
        { name: 'Custom Component', value: 'customComponents' },
        { name: 'Products List', value: 'productsList' },
        { name: 'Insoles Prescription', value: 'insolesPrescription' },
      ]
    }

  ]

  questionTypes = [...this.baseQuestionTypes];

  questionTypeArr = this.baseQuestionTypeArr.map((group) => ({
    ...group,
    questionTypes: [...group.questionTypes]
  }));

  questionIcons = {
    inputText: { icon: 'bi bi-input-cursor-text', color: '#369bfb' },
    longText: { icon: 'bi bi-file-text', color: '#69b5fc' },
    email: { icon: 'bi bi-envelope', color: '#98cdfc' },
    dropdown: { icon: 'bi bi-menu-button-wide-fill', color: '#d65c99' },
    uniqueChoice: { icon: 'bi bi-ui-radios', color: '#de7faf' },
    multipleChoice: { icon: 'bi bi-ui-checks', color: '#d55b98' },
    customComponents: { icon: 'bi bi-postcard-fill', color: '#fa9e31' },
    productsList: { icon: 'bi bi-box-fill', color: '#adebe4' },
    insolesPrescription: { icon: 'bi bi-box-fill', color: '#adebe4' }
  }

  questionForm: FormGroup;
  currentStep: number = 0
  questions: FormArray
  selectedType: string
  choices: FormArray
  components: FormArray
  products: FormArray
  choicesCurrentInd: number = 0
  componentCurrentId: number = 0
  optionCurrentInd: number = 0
  options: FormArray
  isQuestionPopup: boolean = false
  customFormList: any = []
  isEdit: boolean = false
  editedItem: any = [];
  inputCustomForm;
  scanLink: string = 'https://pshm.samcomtechnobrains.com/'
  isScnAccess = false

  visible: boolean = false;
  position: DialogPosition = DialogPosition.Bottom
  uploadControl;
  isModalVisible: boolean = false;
  isFormTypePopup: boolean = false;
  showCustomFormPopup: boolean = false;
  isSubscibed: boolean = false;
  isRequiredQue: boolean = false;
  loading: boolean = true;
  services: Service[];
  productList = [];
  selectedProducts = [];
  questionsList = [];

  createCustomForm: FormGroup;
  selectedImageUrl: string = 'assets/images/no-image.png';
  updateForm: FormGroup;

  requireScansControl: FormControl;
  filteredFormList = [];
  hasProFeatures: boolean = false
  showProFeaturesModal: boolean = false
  clientId: string


  ngOnInit(): void {
    this.applyQuestionTypePermissions();
    this.loadService();
    this.listClients();
    this.getAllCustomForm();
    this.questionForm = this.fb.group({
      name: ['', [Validators.required]],
      userId: [''],
      requireScans: new FormControl(false),
      requireWeb3DScans: new FormControl(false),
      assignedToCustomers: new FormArray([]),
      questions: new FormArray([])
    });
    this.getAllProduct();
    this.checkProFeatures()
    this.loadPrescriptionTemplates();

    this.requireScansControl = this.questionForm.get('requireScans') as FormControl
  }

  private canUseProductsListType(): boolean {
    return !!this.userService.user?.connectedStripeId;
  }

  private applyQuestionTypePermissions(): void {
    const canUseProductsList = this.canUseProductsListType();

    this.questionTypes = canUseProductsList
      ? [...this.baseQuestionTypes]
      : this.baseQuestionTypes.filter((type) => type !== 'productsList');

    this.questionTypeArr = this.baseQuestionTypeArr.map((group) => ({
      ...group,
      questionTypes: canUseProductsList
        ? [...group.questionTypes]
        : group.questionTypes.filter((qtype) => qtype.value !== 'productsList')
    }));
  }

  private blockProductsListWithoutStripe(): boolean {
    if (this.canUseProductsListType()) {
      return false;
    }

    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Products List is only available for users with connected Stripe account.'
    });
    return true;
  }

  listClients() {
    this.clientsService.getClients().subscribe(clients => {
      this.clientList = clients?.map(({ name, ID, userID, email, bill }) => ({ name, ID, userID, email, bill }));
    })
  }

  getAllProduct() {
    this.productService.getAllProduct().subscribe(async (res: any) => {
      this.productList = res.products;
    })
  }

  async loadPrescriptionTemplates() {
    try {
      const clientId = this.userService.user.role === 'ROLE_CUSTOMER'
        ? this.userService.user.client?.id
        : this.clientId;

      if (clientId) {
        this.prescriptionTemplates = await lastValueFrom(
          this.prescriptionTemplatesService.getPrescriptionTemplatesByClientID(clientId)
        );
      }
    } catch (error) {
      console.error('Error loading prescription templates:', error);
      this.prescriptionTemplates = [];
    }
  }

  loadService() {
    this.servicesService.getServices().subscribe((services) => {
      this.services = services
      services.map(service => {
        if (service.name === "Pro features") {
          this.hasProFeatures = true
          this.getAllCustomForm();
        }
      })
    });
  }

  openGallery(event: Event, item: any, j: number): void {
    // Prevent the default behavior of the file input
    event.preventDefault();
    event.stopPropagation();

    // Open the gallery dialog or perform other actions here
    this.showDialog('bottom', item, j);

  }

  showDialog(position: string, control: any, index: number) {
    this.position = position as DialogPosition;
    this.visible = true;
    this.uploadControl = control;
  }

  showTypeModal() {
    if (this.questions.invalid || this.questionForm.value.name === "" || this.questionsControls.invalid) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill all mandatory fields' });
      return false;
    }

    // If the form is valid, set isFormTypePopup to true
    this.isFormTypePopup = true;
    return true
  }


  selectQuestionType(qtype) {
    if (qtype === 'productsList' && this.blockProductsListWithoutStripe()) {
      return;
    }

    this.selectedQueType = qtype;
    this.isFormTypePopup = false;
    this.isRequiredQue = false;
    const questionFormArray = this.questionForm.get('questions') as FormArray;
    questionFormArray.controls.push(this.createQuestion({ type: qtype }))
    if (qtype === 'customComponents') {
      this.addComponent(questionFormArray.length - 1, this.componentCurrentId - 1)
    }
    if (qtype === 'multipleChoice' || qtype === 'uniqueChoice') {
      this.selectedType = qtype
      this.addChoices(questionFormArray.controls.length - 1, -1)
    }
    this.selectedQueIndex = this.questionsList.length + 1;
    if (this.questionIcons && this.questionIcons[qtype]) {
      this.questionsList = [...this.questionsList, { icon: this.questionIcons[qtype].icon, type: qtype, command: () => this.moveToQuestion(this.selectedQueIndex) }];
      this.setSelectedQuestionIndex(questionFormArray.controls.length - 1, this.questionsList[this.selectedQueIndex - 1]);

      this.cd.detectChanges();
    }
  }

  // This function is used to set the selected question index and update the form with the selected question's information.
  setSelectedQuestionIndex(selectedQueIndex: number, selectedQuestion) {
    this.currentStep = selectedQueIndex;
    // this.selectedQueIndex = selectedQueIndex;
    const questionFormArray = this.questionForm.get('questions') as FormArray;
    questionFormArray.controls.forEach((question, qIndex) => {
      this.customComponent.forEach((component, index) => {
        this.componentsControls(qIndex).controls[index] = component.customForm
      })
    })
    this.cd.detectChanges();
    this.selectedQueType = selectedQuestion.type;

    this.selectedType = selectedQuestion.type
    if (selectedQuestion.type === 'customComponents') {
      this.inputCustomForm = (this.questionsControls.at(selectedQueIndex).get("components") as FormArray).getRawValue();
    }
    this.typeChange(this.selectedQueType, questionFormArray.controls.length - 1);
  }

  nextQuestion(step: number, i: number): void {
    console.log("Entro en nextQuestion")
    if (this.questions.controls[i].invalid) {
      alert('Please fill all mendatory field')
    } else {
      this.cd.detectChanges();
      this.currentStep = step + 1;
      this.selectedType = this.questionForm.value.questions[this.currentStep] ? this.questionForm.value.questions[this.currentStep].type : '';
      const formType = this.questionForm.value.questions[step] ? this.questionForm.value.questions[step].type : ''
      if (formType === 'customComponents') {
        if (this.customComponent) {
          this.questionsControls.at(step).get("components")['controls'] = []
          this.customComponent.forEach((component) => {
            const componentVal = component.submit();
            this.componentsControls(step).push(componentVal);
          })
        }
      }


      if (this.isEdit && (this.editedItem.questions.length > this.currentStep)) {
        if (this.selectedType === 'customComponents') {
          this.inputCustomForm = this.componentsControls(this.currentStep).getRawValue();
          this.cd.detectChanges();
        } else {
          this.editedItem.questions[step] = this.questionForm.getRawValue().questions[step];
          this.editValue(this.editedItem, this.currentStep)
        }
      } else {
        if (this.selectedType === 'customComponents') {
          this.inputCustomForm = this.componentsControls(this.currentStep).getRawValue();
          this.cd.detectChanges();
        }
        if (this.selectedType == '' && this.questionForm.value.questions.length === this.currentStep) {
          this.addQuestion();
        }
      }
    }
  }

  backQuestion() {
    if (this.currentStep > 0) {
      this.currentStep--
      this.selectedType = this.questionForm.value.questions &&
        this.questionForm.value.questions[this.currentStep] &&
        this.questionForm.value.questions[this.currentStep].type
        ? this.questionForm.value.questions[this.currentStep].type
        : '';

      if (this.selectedType === 'customComponents') {
        this.questionsControls.at(this.currentStep + 1).get("components")['controls'] = []
        this.customComponent.forEach((component) => {
          const componentVal = component.submit();
          this.componentsControls(this.currentStep + 1).push(componentVal);
        })
      } else if (this.selectedType !== '') {
        this.questionForm.value.questions[this.currentStep] = this.questionForm.getRawValue().questions[this.currentStep];
        this.typeChange(this.selectedType, this.currentStep);
      }

      else {
        this.inputCustomForm = undefined;
        this.typeChange('', this.selectedQueIndex)
        this.choices = this.questionsControls.at(this.selectedQueIndex).get("choices") as FormArray;
        this.choicesCurrentInd = this.choices.length - 1
      }
    }
  }

  addCustomForm(): void {
    this.createCustomForm.reset();
    this.showCustomFormPopup = true;
  }

  addQuestion(): void {
    this.questions = this.questionForm.get('questions') as FormArray;
    this.questions.push(this.createQuestion(''));
  }


  // This function is called when the value of the "name" form control is changed.
  changeFormName(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.questionsList[this.selectedQueIndex].name = inputValue;
  }

  changeTitle(questionIndex: number, event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.questionsList[questionIndex].title = inputValue;
    this.questionsControls.updateValueAndValidity();
  }

  changeSubTitle(questionIndex: number, event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.questionsList[questionIndex].subtitle = inputValue;
    this.questionsControls.updateValueAndValidity();
  }

  changeOptionsList(questionIndex: number, event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.questionsList[questionIndex].options = inputValue;
    this.questionsControls.updateValueAndValidity();
  }

  moveToQuestion(queIndex) {
    this.currentStep = queIndex;
  }

  setQueType(i: number) {
    const currentType = (this.questionsControls.controls[i] as FormGroup).controls['type'].value;

    if (this.selectedQueType === 'productsList' && this.blockProductsListWithoutStripe()) {
      this.selectedQueType = currentType;
      return;
    }

    (this.questionsControls.controls[i] as FormGroup).controls['type'].setValue(this.selectedQueType);
    this.questionsList[i].type = this.selectedQueType
    this.questionsList[i].icon = this.questionIcons[this.selectedQueType].icon
    this.typeChange(this.selectedQueType, i);
    if (this.selectedQueType === 'customComponents') {
      this.questionsControls.at(i).get("components")['controls'] = []
      this.removeComponent(i, this.componentCurrentId)
      this.removeChoices(i, this.choicesCurrentInd)
      this.addComponent(i, this.componentCurrentId - 1)
    }
    if (this.selectedQueType === 'multipleChoice' || this.selectedQueType === 'uniqueChoice') {
      this.questionsControls.at(i).get("choices")['controls'] = []
      this.removeChoices(i, this.choicesCurrentInd)
      this.addChoices(i, -1);
    }
  }

  changeRequired(i: number, event: Event): void {
    const currentQuestion = this.questionsControls.at(i) as FormGroup;
    currentQuestion.controls['required'].setValue((event.target as HTMLInputElement).checked);
  }

  toggleImage(image) {
    this.selectedImage = this.selectedImage === image ? null : image;
  }

  uploadImage() {
    this.uploadControl.controls.image.setValue(this.selectedImage.path);
    this.visible = false;
    this.selectedImage = undefined;
  }

  uploadFile() {
    this.uploadControl.controls.image.setValue(this.selectedImage.path);

    this.visible = false;
    this.selectedImage = undefined;
  }


  handleUpload(event, j, item) {
    const file = event.target.files[0];

    if (file) {
      const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      if (!allowedFileTypes.includes(file.type)) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid file type. Please select a valid image file.' });
        event.target.value = '';

      } else {
        const reader = new FileReader();
        reader.onload = () => {
          const name = file.name;
          const base64 = reader.result.toString();
          const blob = base64.split(",")[1];
          Swal.showLoading()
          this.productService.uploadFile(name, blob).subscribe(
            (res: any) => {
              item.controls.image.setValue(res.fileUrl);
              Swal.close()
              // Set the selectedImageUrl for the specific item
              // item.selectedImageUrl = res.fileUrl;
            },
            (error) => {
            }
          );
        };
        if (file) {
          reader.readAsDataURL(file);
        }
      }
    }
  }


  selectImage(event, item, j) {
    this.handleUpload(event, j, item);
  }


  get questionsControls() {
    return this.questionForm.get("questions") as FormArray;
  }

  choicesControls(id: number) {
    return this.questionsControls.at(id).get("choices") as FormArray;
  }

  componentsControls(id: number) {
    return this.questionsControls.at(id).get("components") as FormArray;
  }

  addComponents(id, component) {
    this.components = this.questionsControls.at(id).get('components') as FormArray;
    this.components.push(component);
  }

  optionControls(choiceInd: number, optInd: number): FormArray {
    const choiceGroup = this.questionsControls.at(choiceInd) as FormGroup; // FormGroup
    const choicesArray = choiceGroup.get('choices') as FormArray; // FormArray
    const optionGroup = choicesArray.at(optInd) as FormGroup; // FormGroup
    const optionsArray = optionGroup.get('options') as FormArray; // FormArray
    return optionsArray; // Devuelves un FormArray
  }

  addChoices(id, choicesInd): void {
    this.choices = this.questionsControls.at(id).get("choices") as FormArray;
    this.choicesCurrentInd = choicesInd + 1

    if (this.selectedType === 'multipleChoice' || this.selectedType === 'uniqueChoice') {
      this.choices.push(this.createChoices(''));
      this.addOption(id, this.choicesCurrentInd, this.optionCurrentInd)
    }
  }

  removeChoices(id, opId): void {
    this.choices = this.questionsControls.at(id).get("choices") as FormArray;
    this.choices.removeAt(opId);
    this.choicesCurrentInd = opId - 1
  }

  addComponent(id, componentId): void {
    // this.inputCustomForm = []

    this.customComponent.forEach((component, index) => {
      this.componentsControls(id).controls[index] = component.customForm

    })
    this.components = this.componentsControls(id);

    this.componentCurrentId = componentId + 1;
    this.components.push(this.createComponent(''));
    this.inputCustomForm = this.components.getRawValue()
  }

  removeComponent(id, componentId): void {
    this.components = this.questionsControls.at(id).get("components") as FormArray;
    this.components.removeAt(componentId);
    this.componentCurrentId = componentId - 1;
    this.inputCustomForm = this.componentsControls(this.currentStep).getRawValue();
  }

  addOption(id, choicesInd, optInd) {
    const optionControls = this.questionsControls.at(id).get("choices") as FormArray;
    this.options = optionControls.at(choicesInd).get("options") as FormArray
    this.options.push(this.createOptions(''));
    this.optionCurrentInd = optInd + 1
  }

  removeOption(id, choicesInd, optInd) {
    const optionControls = this.questionsControls.at(id).get("choices") as FormArray;
    this.options = optionControls.at(choicesInd).get("options") as FormArray
    this.options.removeAt(optInd - 1);
    this.optionCurrentInd = optInd - 1
  }

  createQuestion(ele): FormGroup {
    return this.fb.group({
      id: [ele.id ? ele.id : ''],
      title: [ele.title ? ele.title : '', [Validators.required, CreateCustomFormComponent.noSpaceValidator()]],
      subtitle: [ele.subtitle ? ele.subtitle : '', [Validators.required, CreateCustomFormComponent.noSpaceValidator()]],
      type: [ele.type ? ele.type : '', Validators.required],
      required: [ele.required ? ele.required : false],
      choices: this._getFormArrayFun(ele),
      options: [ele.options ? ele.options : ''],
      components: this._componentFormArray(ele?.components),
      products: [ele.products ? ele.products : ''],
      defaultFocus: [''],
      annotations: ['']
    });
  }

  private _componentFormArray(data): FormArray {
    let fa: FormArray = this.fb.array([])
    if (data?.length) {
      data.forEach((el) => {
        fa.controls.push(this.createComponent(el));
      })
    }
    return fa
  }

  createComponent(ele): FormGroup {
    return this.fb.group({
      image: [ele.image ? ele.image : ''],
      imageSize: [ele.imageSize ? ele.imageSize : 'medium'],
      imagePosition: [ele.imagePosition ? ele.imagePosition : 'top'],
      title: [ele.title ? ele.title : ''],
      numberInputWithLabels: [ele?.choices?.numberInputWithLabels ? ele?.choices?.numberInputWithLabels : []],
      dropdownWithLabel: [ele?.choices?.dropdownWithLabel ? ele?.choices?.dropdownWithLabel : []],
      checkboxWithLabel: [ele?.choices?.checkboxWithLabel ? ele?.choices?.checkboxWithLabel : []],
      radioButtons: [ele?.choices?.radioButtons ? ele?.choices?.radioButtons : []],
    });
  }

  private _getFormArrayFun(data): FormArray {
    let fa: FormArray = this.fb.array([])
    if (data?.choices?.length) {
      data.choices.forEach((el) => {
        if (el) {
          fa.controls.push(this._returnFormGroup(el))
        }
      })
    }
    return fa
  }

  private _returnFormGroup(ele): FormGroup {
    let fg = this.fb.group({
      image: [ele.image ? ele.image : '', Validators.required],
      title: [ele.title ? ele.title : ''],
      prescriptionTemplateId: [ele.prescriptionTemplateId ? ele.prescriptionTemplateId : null],
      options: this._optionFormArray(ele)
    })
    return fg
  }

  private _optionFormArray(data): FormArray {
    let fa: FormArray = this.fb.array([])
    if (data?.options?.length) {
      data.options.forEach((el) => {
        if (el) {
          fa.controls.push(this.createOptions(el))
        }
      })
    }
    return fa
  }

  createOptions(ele): FormGroup {
    return this.fb.group({
      name: [ele.name ? ele.name : '', Validators.required],
      isSelected: [ele.isSelected ? ele.isSelected : false],
    });
  }



  createChoices(ele): FormGroup {
    return this.fb.group({
      image: [ele.image ? ele.image : '', Validators.required],
      title: [ele.title ? ele.title : ''],
      prescriptionTemplateId: [ele.prescriptionTemplateId ? ele.prescriptionTemplateId : null],
      options: this.fb.array([])
    });
  }



  createCustomComponent(ele): FormGroup {
    return this.fb.group({
      image: [ele.image ? ele.image : ''],
      title: [ele.title ? ele.title : ''],
      numberInputWithLabels: [ele?.numberInputWithLabels ? ele?.numberInputWithLabels : []],
      dropdownWithLabel: [ele?.dropdownWithLabel ? ele?.dropdownWithLabel : []],
      checkboxWithLabel: [ele?.checkboxWithLabel ? ele?.checkboxWithLabel : []],
      radioButtons: [ele?.radioButtons ? ele?.radioButtons : []],
    });
  }



  typeChange(event, index) {
    this.selectedType = event ? event : this.questions.controls[index].value.type
  }

  questionSubmit(i: number): boolean {
    this.questionsControls.updateValueAndValidity();
    let error = false;

    // Validar si hay errores en los componentes personalizados
    if (this.selectedType === 'customComponents') {
      this.customComponent.forEach((component) => {
        const componentVal = component.submit();
        if (componentVal.invalid) {
          error = true;
        }
      });
    }

    // Verificar si el formulario es válido
    if (this.isInvalidForm(i, error)) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill all mandatory fields' });
      return false; // Retornar false si hay un error de validación
    }

    // Si hay componentes personalizados, resetearlos
    if (this.selectedType === 'customComponents') {
      this.resetComponents(i);
    }

    // Si ya estamos en el proceso de envío, no hacer nada
    if (this.isSubmitting) return false;

    this.isSubmitting = true;

    let payload = this.createPayload();
    this.addClientToPayload(payload);

    // Aquí vamos a manejar la llamada asincrónica y retornamos un valor
    this.submitForm(payload);

    return true; // Si todo ha ido bien hasta este punto, retornamos true
  }

  isInvalidForm(i: number, error: boolean): boolean {
    return (
      this.questions.controls[i].invalid ||
      this.questionForm.value.name === "" ||
      error ||
      this.questionsControls.invalid
    );
  }

  resetComponents(i: number): void {
    this.questionsControls.at(i).get("components")['controls'] = [];
    this.components = this.questionsControls.at(i).get("components") as FormArray;
    this.customComponent.forEach((component) => {
      const componentVal = component.submit();
      this.components.push(componentVal);
    });
  }

  createPayload(): any {
    let payload = this.questionForm.getRawValue();

    // Ensure requireScans and requireWeb3DScans are set to false if they're null or undefined
    payload.requireScans = payload.requireScans !== null && payload.requireScans !== undefined
      ? payload.requireScans
      : false;

    payload.requireWeb3DScans = payload.requireWeb3DScans !== null && payload.requireWeb3DScans !== undefined
      ? payload.requireWeb3DScans
      : false;

    payload.questions = this.questionsControls.getRawValue();

    // Debug: Log para verificar que prescriptionTemplateId está presente
    console.log('Payload questions before processing:', JSON.stringify(payload.questions, null, 2));

    payload.questions.forEach((question) => {
      if (question.type === 'customComponents') {
        question.components.forEach((component, index) => {
          const newComponent = {
            title: component.title,
            image: component.image,
            imageSize: component.imageSize || 'medium',
            imagePosition: component.imagePosition || 'top',
            choices: {
              numberInputWithLabels: component.numberInputWithLabels,
              dropdownWithLabel: component.dropdownWithLabel,
              checkboxWithLabel: component.checkboxWithLabel,
              radioButtons: component.radioButtons,
            }
          };
          question.components[index] = newComponent;
        });
      }

      // Asegurar que prescriptionTemplateId se mantenga en uniqueChoice choices
      if (question.type === 'uniqueChoice' && question.choices) {
        question.choices = question.choices.map(choice => ({
          image: choice.image,
          title: choice.title,
          prescriptionTemplateId: choice.prescriptionTemplateId || null,
          options: choice.options || []
        }));
      }
    });

    // Remove empty choices, options, or components
    payload.questions.forEach((ele) => {
      if (ele.choices && ele.choices.length === 0) {
        delete ele['choices'];
      }
      if (ele.options && ele.options.length === 0) {
        delete ele['options'];
      }
      if (ele.components && ele.components.length === 0) {
        delete ele['components'];
      }
    });

    return payload;
  }

  addClientToPayload(payload: any): void {
    if (this.selectedClient && this.selectedClient.length > 0) {
      payload.assignedToCustomers = this.selectedClient.length === this.clientList.length
        ? ["*"]
        : this.selectedClient.map(({ ID }) => ID);
    }
  }

  submitForm(payload: any): void {
    const formAction = this.isEdit
      ? this.customerFormService.updateCustomForm(this.editedItem.ID, payload)
      : this.customerFormService.addCustomForm(payload);

    // Suscripción al observable, manejando el éxito y el error
    formAction.subscribe({
      next: async (res) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Form has been updated successfully' });
        await this.getAllCustomForm();
        this.isQuestionPopup = false;
        this.formClear();
        this.isSubmitting = false;
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.message });
        this.isSubmitting = false;
      }
    });
  }


  onScanAccessChange(checked: boolean) {
    // Update the value of the form control programmatically
    this.questionForm.get('requireScans').setValue(checked);
  }

  closePopup(): void {
    this.isQuestionPopup = false
    this.isEdit = false
    this.editedItem = []
    this.formClear()
    this.search = ''
    this.getAllCustomForm();
  }

  getAllCustomForm(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.customerFormService.getCustomForm().subscribe({
        next: (res) => {
          this.customFormList = res;
          this.filteredFormList = res;
          this.loading = false;
          resolve();
        },
        error: (err) => {
          console.error("Error getting custom forms: ", err);
          reject(err);
        }
      });
    });
  }


  deleteForm(id: string, event: Event) {
    event.stopPropagation();
    if (this.isDeleting) {
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.isDeleting = true;
        this.customerFormService.deleteCustomForm(id).subscribe((res) => {
          const index = this.customFormList.findIndex((question) => question.ID === id);
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Form has been deleted successfully' });
          this.customFormList.splice(index, 1);
          this.getAllCustomForm();
          this.isDeleting = false;
        }, (err) => {
          this.isDeleting = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete form' });
        });
      }
    });
  }

  formClear() {
    this.questionForm.reset()
    this.selectedType = ' '
    this.isEdit = false
    this.editedItem = []
    const questionArry = this.questionForm.get('questions') as FormArray;
    questionArry.controls = [];
    this.selectedQueType = '';
    this.isRequiredQue = false;
    this.questionsList = [];
    this.search = ''
  }

  editValue(item, index) {
    this.choicesCurrentInd = -1
    this.optionCurrentInd = -1
    this.editedItem = item
    this.isQuestionPopup = true
    this.isEdit = true

    this.selectedClient = []

    // Asignar todos los clientes si 'assignedToCustomers' es un asterisco ('*')
    if (item.assignedToCustomers && item.assignedToCustomers[0] === '*') {
      this.selectedClient = [...this.clientList];  // Clonar todos los clientes
    } else if (item.assignedToCustomers && Array.isArray(item.assignedToCustomers)) {
      // Si no es un asterisco, asignar solo los clientes especificados en 'assignedToCustomers'
      item.assignedToCustomers.map((customerId) => {
        let foundClient = this.clientList.find((client) => client.ID === customerId);
        if (foundClient) {
          this.selectedClient.push(foundClient);
        } else {
          console.warn(`Cliente con ID ${customerId} no encontrado en la lista de clientes.`);
        }
      });
    } else {
      console.warn('No hay clientes asignados o el formato de "assignedToCustomers" es incorrecto.');
    }


    this.questionForm.patchValue({
      name: item.name,
      userId: item.userId,
      requireScans: item.requireScans,
      requireWeb3DScans: item.requireWeb3DScans || false,
    });
    this.updateForm.patchValue({
      name: item.name.trim()
    })
    this.selectedType = item.questions[index]?.type;
    this.selectedQueType = item.questions[index]?.type;
    this.questions = this.questionForm.get('questions') as FormArray;
    item.questions.forEach((question, q_index) => {
      this.questionsControls.controls.push(this.createQuestion(question))
    })
    if (this.selectedType === 'productsList') {
      this.questionsControls.at(index).get('products').setValue(item.questions[index].products);
    }
    item.questions.forEach((element, index) => {
      if (this.questionIcons && this.questionIcons[element.type]) {
        let questions = ({ ...element, ...this.questionIcons[element.type] })
        this.questionsList.push(questions)
      }
    });

    // Asignar inputCustomForm basado en la pregunta actual
    if (this.selectedType === 'customComponents') {
      // Obtener los datos originales del servidor, no del FormGroup
      this.inputCustomForm = item.questions[index].components || [];
      this.cd.detectChanges();
    }

  }

  removeItem(i: number): void {
    if (this.questionsList && this.questionsList.length > 0) {
      this.questionsList.splice(i, 1);

      this.questions = this.questionForm.get('questions') as FormArray;

      if (this.questions && i >= 0 && i < this.questions.length) {
        this.questions.removeAt(i);
      }

      this.backQuestion();
      this.selectedQueType = this.questionForm.value.questions[this.currentStep].type;
    }
  }


  scanAccess() {
    if (this.userService.user.role === "ROLE_CUSTOMER" && (this.questionForm.value.requireScans)) {
      this.isScnAccess = true
      this.scanLink = environment.base_url_second + '/email=' + this.userService.user.email + '&uuid=' + this.userService.user.ID
    } else {
      this.isQuestionPopup = false
    }
  }

  scanBack() {
    this.isScnAccess = false
    this.isQuestionPopup = false
  }

  /**
   * Create Custom form
   */
  private _initCreateCustomForm(): void {
    this.createCustomForm = this.fb.group({
      name: ['', [Validators.required, CreateCustomFormComponent.noSpaceValidator()]],
      userId: [''],
      requireScans: [false],
      requireWeb3DScans: [false],
      assignedToCustomers: new FormArray([]),
      questions: new FormArray([]),
      clientId: ['']
    })
  }

  private _initUpdateForm(): void {
    // Initialize the update form with the required and custom validators
    this.updateForm = this.fb.group({
      name: ['', [Validators.required, CreateCustomFormComponent.noSpaceValidator(), Validators.maxLength(50),
      Validators.minLength(3)]],
    });
  }

  /**
   * Create New Form
   */
  public createNewForm() {

    if (this.createCustomForm.value.name === "" || this.createCustomForm.value.name === null || this.createCustomForm.invalid) {
      this.createCustomForm?.markAllAsTouched();
      return;
    }

    if (this.isFormSubmitting) {
      return;
    }

    this.isFormSubmitting = true;

    if (this.userService.user.role == "ROLE_CUSTOMER") {

      this.clientId = this.userService.user.client.id
      console.log("Es customer, clientId: ", this.clientId)
      this.createCustomForm.value.clientId = this.clientId
    }

    // Ensure requireScans and requireWeb3DScans are set to false if they're null or undefined
    const payload = {
      ...this.createCustomForm.value,
      requireScans: this.createCustomForm.value.requireScans !== null && this.createCustomForm.value.requireScans !== undefined
        ? this.createCustomForm.value.requireScans
        : false,
      requireWeb3DScans: this.createCustomForm.value.requireWeb3DScans !== null && this.createCustomForm.value.requireWeb3DScans !== undefined
        ? this.createCustomForm.value.requireWeb3DScans
        : false
    };

    console.log("Payload: ", payload)


    this.customerFormService.addCustomForm(payload).subscribe({
      next: async (res) => {
        if (res['ID']) {
          await this.getAllCustomForm();

          this.router.navigate([`custom-form/${res['ID']}`])

          // const customItem = this.customFormList.filter((item) => item.ID === res['ID']);

          // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Form has been created successfully' });
          this.showCustomFormPopup = false;
          this.isFormSubmitting = false;

          // if (customItem.length > 0) {
          //   this.editValue(customItem[0], 0);
          // }
        }
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'error', detail: err?.error?.message });
        this.showCustomFormPopup = false;
        this.isFormSubmitting = false;
      }
    });
  }

  public updateFormName() {
    if (this.updateForm.invalid) return
    else {
      if (this.isFormNameSubmitting) {
        return;
      }

      this.isFormNameSubmitting = true;

      const payload = {
        name: this.updateForm.value.name
      }

      this.customerFormService.updateCustomFormName(this.editedItem.ID, payload).subscribe({
        next: async (res) => {
          await this.getAllCustomForm();
          this.isFormNameSubmitting = false;
          this.isInputChanged = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Form name has been updated successfully' });
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'error', detail: err?.error?.message });
          this.isInputChanged = false;
          this.showCustomFormPopup = false;
          this.isFormNameSubmitting = false;
        }
      });
    }
  }

  /**
   * Set Form Value 
   * @param value : input Value
   */
  public setValueinFormName(eventTarget): void {
    const value = eventTarget.value
    this.updateForm.get('name').patchValue(value);
    this.isInputChanged = true;
  }

  //clientSelected
  public clientSelected() {
    console.log('selectedClient', this.selectedClient)
  }

  static noSpaceValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const value = control.value;
      if (value && value.toString().startsWith(' ')) {
        return { noWhiteSpaceValidator: true };
      }
      return null;
    };
  }

  // Función para filtrar los datos basados en el search
  applyFilter() {
    this.filteredFormList = this.customFormList.filter(item =>
      item.name.toLowerCase().includes(this.search.toLowerCase())
    );
  }

  seeCustomForm(customFormId: string, referenceId: string) {

    if (referenceId) {
      this.router.navigate([`/view-custom-form/${customFormId}`], {
        queryParams: { referenceId: referenceId }
      });
    } else {
      this.router.navigate([`/view-custom-form/${customFormId}`]);
    }


  }

  goToCustomFormDetails(customFormId: string) {
    this.router.navigate([`/custom-form/${customFormId}`])
  }

  checkProFeatures() {
    this.servicesService.getServices().subscribe((services) => {
      this.hasProFeatures = services.some(service => service.name === "Pro features");

      if (!this.hasProFeatures) {
        this.showProFeaturesModal = true
      }
    });
  }

  buyPROSubscription() {
    Swal.showLoading()
    this.showProFeaturesModal = false
    this.servicesService.subscribe('Pro features').subscribe(result => {
      if (result) {
        this.loadService()
        Swal.close()
      }
    })
  }
}
